module.exports = "<div class=\"footer\">\r\n  Powered by Vikas Global Solutions Ltd. 2018\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/footer/footer.component.html
// module id = ./src/app/common/footer/footer.component.html
// module chunks = main